import { render, staticRenderFns } from "./HandleType.vue?vue&type=template&id=26a2ca24&"
import script from "./HandleType.vue?vue&type=script&lang=js&"
export * from "./HandleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports